import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID  } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

import { AppComponent } from './app.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { MainNavInfComponent } from './main-nav-inf/main-nav-inf.component';
import { MainContainerComponent } from './main-container/main-container.component';
import { InfoListOcurrenceComponent } from './info-list-ocurrence/info-list-ocurrence.component';
import { BoxInfoOcurrenceComponent } from './box-info-ocurrence/box-info-ocurrence.component';
import { BoxGraphicStatisticComponent } from './box-graphic-statistic/box-graphic-statistic.component';
import { ApiConService } from './shared/api-con.service';

import { SelListOcurrence } from './shared/mock.list-ocurrence';
import { MainNavInfService } from './main-nav-inf/main-nav-inf.service';
import { InfoListOcurrenceService } from './info-list-ocurrence/info-list-ocurrence.service';
import { BoxGraphicStatisticService } from './box-graphic-statistic/box-graphic-statistic.service';
import { PopupOcorrenciaComponent } from './popup-ocorrencia/popup-ocorrencia.component';
import { MainContainerService } from './main-container/main-container.service';
import { PopupOcorrenciaService } from './popup-ocorrencia/popup-ocorrencia.service';
import { Util } from './shared/util.service';
import { PopupConfigComponent } from './popup-config/popup-config.component';
import { PopupNovaOcorrenciaComponent } from './popup-nova-ocorrencia/popup-nova-ocorrencia.component';
import { PopupConfigService } from './popup-config/popup-config.service';
import { PopupNovaOcorrenciaService } from './popup-nova-ocorrencia/popup-nova-ocorrencia.service';
import { ToastNoAnimationModule } from 'ngx-toastr';
import { CpfCnpjPipe } from './shared/cpfcnpj.pipe';
import { NomeMotoristaPipe } from './shared/nome-motorista.pipe';
import { MapSaneamentoClieComponent } from './map-saneamento-clie/map-saneamento-clie.component';
import { EsriLoadService } from './shared/esri-load-control.service';
import { TipoOcorrenciaPipe } from './shared/pipes/tipo-ocorrencia.pipe';
import { TextLinkComponent } from './shared/text-link/text-link.component';
import { CardHorarioRecebimentoComponent } from './popup-ocorrencia/card-horario-recebimento/card-horario-recebimento.component';
import { ModalAvaliacaoComponent } from './modal-avaliacao/modal-avaliacao.component';



@NgModule({
  declarations: [
    AppComponent,
    MainHeaderComponent,
    MainNavInfComponent,
    MainContainerComponent,
    InfoListOcurrenceComponent,
    BoxInfoOcurrenceComponent,
    BoxGraphicStatisticComponent,
    PopupOcorrenciaComponent,
    PopupConfigComponent,
    PopupNovaOcorrenciaComponent,
    CpfCnpjPipe,
    NomeMotoristaPipe,
    MapSaneamentoClieComponent,
    TipoOcorrenciaPipe,
    TextLinkComponent,
    CardHorarioRecebimentoComponent,
    ModalAvaliacaoComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    ToastNoAnimationModule.forRoot({preventDuplicates: true,}),
  ],
  providers: [
    EsriLoadService,
    ApiConService,
    SelListOcurrence,
    MainNavInfService,
    InfoListOcurrenceService,
    BoxGraphicStatisticService,
    MainContainerService,
    PopupOcorrenciaService,
    PopupConfigService,
    PopupNovaOcorrenciaService,
    Util,
    { provide: LOCALE_ID, useValue: "pt-BR" }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
